import React from 'react';
import { Button } from '@/components/ui/button';

import type { ProgramControlCommonProps } from '../controlTypes';

type InrepProgramControlsProps = ProgramControlCommonProps & {
  inrepReportProgramOptions: string[];
  onOpenInrepReportDialog: () => void;
};

export const InrepProgramControls = ({
  values,
  onFilterChange,
  actionRowClass,
  renderStandardActionButtons,
  renderReportActionLabel,
  inrepReportProgramOptions,
  onOpenInrepReportDialog,
}: InrepProgramControlsProps) => (
  <div className="mb-3 flex flex-wrap items-end justify-between gap-4 rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-40)] bg-white px-4 py-3">
    <div className="flex flex-wrap items-center gap-6">
      <div className="flex items-center gap-3">
        <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">Status</div>
        <div className="flex items-center gap-4 text-xs text-[var(--neutral-gray-120)]">
          <label className="flex items-center gap-1.5"><input type="radio" name="inrep-closed" checked={values.inrepClosedFilter === 'all'} onChange={() => onFilterChange('inrepClosedFilter', 'all')} />All</label>
          <label className="flex items-center gap-1.5"><input type="radio" name="inrep-closed" checked={values.inrepClosedFilter === 'n'} onChange={() => onFilterChange('inrepClosedFilter', 'n')} />Open</label>
          <label className="flex items-center gap-1.5"><input type="radio" name="inrep-closed" checked={values.inrepClosedFilter === 'y'} onChange={() => onFilterChange('inrepClosedFilter', 'y')} />Closed</label>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">Program</div>
        <div className="flex flex-wrap items-center gap-4 text-xs text-[var(--neutral-gray-120)]">
          <label className="flex items-center gap-1.5"><input type="radio" name="inrep-program" checked={values.inrepProgramFilter === 'all'} onChange={() => onFilterChange('inrepProgramFilter', 'all')} />All</label>
          {inrepReportProgramOptions.map((program) => (
            <label key={program} className="flex items-center gap-1.5">
              <input type="radio" name="inrep-program" checked={values.inrepProgramFilter === program} onChange={() => onFilterChange('inrepProgramFilter', program)} />
              {program}
            </label>
          ))}
        </div>
      </div>
    </div>

    <div className={actionRowClass}>
      {renderStandardActionButtons()}
      <Button type="button" variant="outline" size="sm" className="h-8" onClick={onOpenInrepReportDialog}>
        {renderReportActionLabel('All Incidents List')}
      </Button>
    </div>
  </div>
);
